import script from "./RegisterInvitePage.vue?vue&type=script&setup=true&lang=js"
export * from "./RegisterInvitePage.vue?vue&type=script&setup=true&lang=js"

import "./RegisterInvitePage.vue?vue&type=style&index=0&id=39294269&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39294269"]])

export default __exports__